import React, { useState, useEffect } from 'react'

import { OnboardingService } from '@/modules/onboarding/onboardingService'
import { useDispatch, useSelector } from 'react-redux'
import { setIndustry } from '@/redux/ducks/onboarding/main'

interface IndustrySearchProps {
  setInputsValid: (valid: boolean) => void
  onChange: null | ((industry) => void)
}

export interface IndustryType {
  name: string
  group: string
  label: string
  labelGroup: string
}

export default function useIndustrySearch(props: IndustrySearchProps) {
  const dispatch = useDispatch()
  const { setInputsValid, onChange = null } = props

  const { industry } = useSelector(state => state.onboarding.main)
  const { subscriptions } = useSelector(state => state.tenant.info)
  const [industries, setIndustries] = useState<IndustryType[]>([])
  const [value, setValue] = useState(null)
  const isTaxConsultant = subscriptions?.some(s => s.isTaxConsultant)

  useEffect(() => {
    const fnc = async() => {
      const preSelection = await OnboardingService.Industry.getAll()
        .then(({ data: industryData }) => {
          setIndustries(industryData)
          if (isTaxConsultant) {
            return industryData.find(({ name }) => name === 'accountant')
          }
          return null
        })
      if (preSelection) {
        onOptionChanged(preSelection)
        setValue(null)
      }
    }
    fnc()
  }, [])

  useEffect(() => {
    if (!value && industries.length > 0) {
      setValue(industries.find(i => i.name === industry.name && i.group === industry.group))
    }
    const {
      name,
    } = industry
    setInputsValid(!!name)
  }, [industry, industries, value])

  useEffect(() => {
    if (
      value
      && (industry.group !== value.group || industry.name !== value.name)
    ) {
      setValue(null)
    }
  }, [industry])

  const onOptionChanged = (industry) => {
    const industryData = {
      name: industry && industry.name ? industry.name : '',
      group: industry && industry.group ? industry.group : '',
    }
    dispatch(setIndustry(industryData))
  }

  const handleChange = (event: React.ChangeEvent, industry) => {
    setValue(industry)
    onOptionChanged(industry)
    onChange && onChange(industry)
  }

  return { industries, value, handleChange }
}
